import { BoxControl, GradientPicker } from '@wordpress/components';
import { VayuBlocksDevice} from '@vayu-blocks/device-control';
import { __ } from '@wordpress/i18n';
import { useState } from 'react';

export const Gradient = ({onChange,dataKey,frameData}) => {

    const deviceView  = VayuBlocksDevice();
    const [firstTablet, setFirstTablet] = useState(false);
    const [firstDesktop, setFirstDesktop] = useState(true);

    const gradienttype = [
        {
            gradient: 'linear-gradient(90deg, rgb(74, 234, 220) 0%, rgb(102, 37, 224) 20%, rgb(0, 0, 0) 40%, rgb(238, 44, 130) 60%, rgb(97, 250, 198) 80%, rgb(237, 0, 0) 100%)',
            name: 'Vivid cyan blue to vivid purple',
            slug: 'vivid-cyan-blue-to-vivid-purple'
        },
        {
            gradient: 'linear-gradient(135deg,rgb(74,234,220) 0%,rgb(151,120,209) 20%,rgb(207,42,186) 40%,rgb(238,44,130) 60%,rgb(251,105,98) 80%,rgb(254,248,76) 100%)',
            name: 'Light green cyan to vivid green cyan',
            slug: 'light-green-cyan-to-vivid-green-cyan'
        },
        {
            gradient: 'linear-gradient(135deg, rgb(255,200,200) 0%, rgb(255,150,150) 20%, rgb(255,100,100) 40%, rgb(255,50,50) 60%, rgb(255,0,0) 80%)',
            name: 'Luminous vivid amber to luminous vivid orange',
            slug: 'luminous-vivid-amber-to-luminous-vivid-orange'
        },
        {
            gradient: 'linear-gradient(135deg, rgb(0,150,255) 0%, rgb(0,200,255) 20%, rgb(0,250,200) 40%, rgb(50,255,150) 60%, rgb(100,255,100) 80%)',
            name: 'Luminous vivid orange to vivid red',
            slug: 'luminous-vivid-orange-to-vivid-red'
        },
        {
            gradient: 'linear-gradient(135deg, rgb(128,0,128) 0%, rgb(186,85,211) 20%, rgb(238,130,238) 40%, rgb(255,165,0) 60%, rgb(255,255,0) 80%)',
            name: 'Very light gray to cyan bluish gray',
            slug: 'very-light-gray-to-cyan-bluish-gray'
        },
        {
            gradient: 'linear-gradient(135deg, rgb(255,99,71) 0%, rgb(255,140,0) 20%, rgb(255,215,0) 40%, rgb(0,128,128) 60%, rgb(0,255,255) 80%)',
            name: 'Cool to warm spectrum',
            slug: 'cool-to-warm-spectrum'
        }
    ]

    const handlegradientchange = (frameData, value) => {
        const updatedAttributes = {
            ...frameData,
            gradient: {
                ...frameData.gradient,
                color: value,
            },
        };
    
        onChange(dataKey, updatedAttributes); // 👈 dataKey used instead of hardcoded 'frameData'
    };
    
    
    const setgradientborderwidth = (frameData,values) =>{
        const attr = frameData.gradient.width;

        // Ensure border object exists before updating
        const updatedAttributes = {
            ...frameData, // Spread existing frameData
            gradient: {
                ...frameData.gradient, 
                width:{
                    ...frameData.gradient.width,
                    [deviceView]: values,
                }
            },
        };
    
        // Check if it's the first time running on this device view
        const isFirstRun = attr?.[deviceView] === undefined;
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        // Device view specific logic
        if (deviceView === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                Object.assign(updatedAttributes.gradient.width, { Tablet: values, Mobile: values });
                localStorage.setItem('firstTablet', 'true'); // Ensure value is string in localStorage
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (deviceView === 'Tablet') {
            if (isTabletFirstRun) {
                Object.assign(updatedAttributes.gradient.width, { Mobile: values });
                localStorage.removeItem('firstTablet'); // Reset localStorage item when Tablet is accessed
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else {
            // For other device views, reset tablet/desktop flags
            setFirstTablet(false);
            setFirstDesktop(false);
        }
    
        onChange(dataKey, updatedAttributes);
    }
    
  return (
    <>
        <GradientPicker
            className='vayu_block_gradientcontrol'
            gradients = {gradienttype}
            onChange={(newValue) => handlegradientchange(frameData,newValue)} 
            value={frameData?.gradient?.color?? "linear-gradient(135deg,rgb(74,234,220) 0%,rgb(151,120,209) 20%,rgb(207,42,186) 40%,rgb(238,44,130) 60%,rgb(251,105,98) 80%,rgb(254,248,76) 100%)"}
        />

        <br/>

        <div className='vayu_blocks_box_control_image'>
            <BoxControl
                label={__('Width', 'vayu-blocks')}
                values={frameData.gradient.width?.[deviceView]}
                onChange={ ( values ) => setgradientborderwidth( frameData, values ) }
            />
        </div>
    </>
  )
}
